var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.063 3.75H3.437c-.862.001-1.561.7-1.562 1.563v11.875c0 .861.701 1.562 1.563 1.562h10.624c.862 0 1.563-.7 1.563-1.563V5.313c0-.86-.7-1.562-1.563-1.562zm.312 13.438c0 .171-.14.312-.313.312H3.438a.312.312 0 01-.313-.313V5.313c0-.172.14-.312.313-.312h10.624c.173 0 .313.14.313.313v11.875zm-2.5-10.157h-6.25a.625.625 0 100 1.25h6.25a.625.625 0 100-1.25zm0 3.125h-6.25a.625.625 0 100 1.25h6.25a.625.625 0 100-1.25zm-2.5 3.099h-3.75a.625.625 0 100 1.25h3.75a.625.625 0 100-1.25z",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.563 1.25H5.938a.625.625 0 100 1.25h10.625c.172 0 .312.14.312.313v11.874a.625.625 0 101.25 0V2.813c0-.862-.7-1.563-1.563-1.563z",
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/assets/copy.305bd39a.svg";
export { ForwardRef as ReactComponent };